import { Interval } from 'luxon'

/**
 * Creates a Luxon Interval from 12 AM Saturday until next week's 12 AM Saturday,
 * which includes the given dateTime
 * @param {DateTime} dateTime DateTime which the paycheck week should include
 * @param {Number} weeklyPaycheckDay Number which the paycheckday 1-7: Monday-Sunday
 * @returns {Interval} Interval from 12 AM Saturday until next week's 12 AM Saturday,
 * which includes the given dateTime
 */
export const getPaycheckIntervalFromDateTime = (dateTime, weeklyPaycheckDay) => {
  // Current week Paycheck Week Start; 12 AM Saturday
  const paycheckWeekStartDateTime = dateTime.startOf('week').plus({ days: weeklyPaycheckDay })
  if (dateTime < paycheckWeekStartDateTime) {
    const startDateTime = paycheckWeekStartDateTime.minus({ week: 1 })
    return Interval.fromDateTimes(startDateTime, paycheckWeekStartDateTime)
  }
  const endDateTime = paycheckWeekStartDateTime.plus({ week: 1 })
  return Interval.fromDateTimes(paycheckWeekStartDateTime, endDateTime)
}
